export default __webpack_public_path__ + "static/media/menu_my_recordings_okara.af3d107a.svg";